import {makeAutoObservable, reaction, when} from "mobx";
import * as Api from "@/api/api";
import {defaultAvatar} from "@/api/commonApi.js";
import AuthUtil from "@/utils/AuthUtil";
import {isDev} from '@/utils/envUtil'

// todo 这里要获取真实的数据
const mockUserId = "mock_user_id"
const mockUserRoleList = ["user", "admin"]

class UserStore {
    token = "";
    userInfo?: any = undefined

    constructor() {
        makeAutoObservable(this)

        this.loadData();
    }

    loadData() {
        this.token = AuthUtil.getToken() || "";
        this.userInfo = AuthUtil.getUserInfo() || undefined;
    }


    get id() {
        return this.userInfo?.id || 0;
    }

    get username() {
        return this.userInfo?.username || '';
    }

    get avatar() {
        return this.userInfo?.avatar || defaultAvatar;
    }

    get nickname() {
        return this.userInfo?.nickname || '';
    }

    get gender() {
        return this.userInfo?.gender || null;
    }

    get birthday() {
        return this.userInfo?.birthday || 0;
    }

    get roleList() {
        return this.userInfo?.roleList || [];
    }


    async fetchInfo() {
        await Api.userInfo();
        this.loadData();
    }

    get isLogin() {
        return !!this.token;
    }
}


const userStore = new UserStore()

// todo 这里是为了测试不每次都登录
if (isDev) {
    // userStore.userInfo = {
    //     avatar: "http://glx.local.com/file/live_mall/file/2024-05-03/6634aa5861c0997755764cb0.jpeg",
    //     birthday: "",
    //     gender: null,
    //     id: 10,
    //     nickname: "mock昵称",
    //     username: "mock_username",
    //     roleList: [
    //         "user", "admin"
    //     ]
    // }
    // userStore.token = 'mock-token'
}

when(() => userStore.isLogin, async () => {
    await userStore.fetchInfo()
})

// reaction(() => user.token, (value) => {
//     // CookieUtil.save('token', value)
//     AuthUtil.setToken(value)
// })

// reaction(() => user.avatar, (value) => {
//     if (!value) {
//         user.avatar = defaultAvatar
//     }
// }, {
//     fireImmediately: true
// })

export default userStore;
export {UserStore}